import LoginCarousel from "./LoginCarousel";
import LoginBanner from "./LoginBanner";
import LoginForm from "./LoginForm";
import LoginMain from "./LoginMain";

export default LoginMain;